import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SearchCommentarySnippetItem } from './SearchCommentarySnippetItem';
import { Connect, PropsFromRedux } from './SearchCommentarySnippetContainer';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import './search_commentary_snippet.scss';
import { ResultsType } from '../../../../state/reducers/results.types';
import { SearchCommentarySnippetSeeMore } from './SearchCommentarySnippetSeeMore';

type Props = PropsFromRedux & {
  commentaries: NonNullable<ResultsType['snippets']['commentaries']>;
};

const RawSearchCommentarySnippet: FC<Props> = ({
  commentaries,
  query,
  onSeeMore,
}) => {
  const onHeaderClick = () => {
    doctrineAnalytics('Search NoButtonClicked', {
      source: 'commentary-snippet-header',
    });
  };

  return (
    <div className="search-commentary-snippet">
      <div
        className="search-commentary-snippet__header"
        onClick={onHeaderClick}
      >
        <p className="search-commentary-snippet__title">
          <FormattedMessage
            id="search/components/search-snippets/main/commentary/SearchCommentarySnippet.tsx/2"
            values={{
              query: (
                <span
                  title={query}
                  className="search-commentary-snippet__query"
                >
                  {query}
                </span>
              ),
              count: commentaries.length,
            }}
          />
        </p>
      </div>
      <div className="search-commentary-snippet__card">
        {commentaries.map((commentary, index) => (
          <SearchCommentarySnippetItem
            index={index}
            key={commentary.commentaireId}
            commentary={commentary}
          />
        ))}
        <SearchCommentarySnippetSeeMore
          commentaries={commentaries}
          query={query}
          onSeeMore={onSeeMore}
        />
      </div>
    </div>
  );
};

export const SearchCommentarySnippet = Connect(RawSearchCommentarySnippet);
